/*!

=========================================================
* Vue Argon Dashboard PRO - v1.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard
* Copyright 2019 Creative Tim (https://www.creative-tim.com)

* Coded by www.creative-tim.com

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import Vue from 'vue';
import DashboardPlugin from './plugins/dashboard-plugin';
import App from './App.vue';

// router setup
import router from './routes/router';
//import router from './routes/routes';
//import router from "./routes/starterRouter";


// Services
import ApiService from './services/api.service'
import { TokenService } from './services/storage.service'


//Vue.prototype.$base_url = "https://csp.thefrontalgroup.com/cs/public";
Vue.prototype.$base_url = process.env.VUE_APP_API_PATH
Vue.prototype.$cs_app_name = process.env.VUE_APP_NAME
Vue.prototype.$cs_app_long_name = process.env.VUE_APP_LONG_NAME
Vue.prototype.$cs_app_default = process.env.VUE_APP_DEFAULT
Vue.prototype.$cs_org_id = process.env.VUE_APP_ORG_ID




// Set the base URL of the API
ApiService.init(process.env.VUE_APP_API_PATH) 

// If token exists set header
if (TokenService.getToken()) { //not in use?
  ApiService.setHeader() 
}

router.beforeEach((to, from, next) => {
  const isPublic = to.matched.some(record => record.meta.public)
  const onlyWhenLoggedOut = to.matched.some(record => record.meta.onlyWhenLoggedOut)
  const loggedIn = !!TokenService.getToken();

  if (!isPublic && !loggedIn) {
    return next({
      path:'/login',
      query: {redirect: to.fullPath}  // Store the full path to redirect the user to after login
    });
  }

  // Do not allow user to visit login page or register page if they are logged in
  if (loggedIn && onlyWhenLoggedOut) {
    return next('/')
  }

   next();
})




// plugin setup
Vue.use(DashboardPlugin);

/* eslint-disable no-new */
new Vue({
  el: '#app',
  render: h => h(App),
  router
});
